import React from 'react';

import { TrailNamesColumnValue } from '../types';

type TrailNamesColumnProps = {
  value: TrailNamesColumnValue;
};

const TrailNamesColumn = ({ value: { trailNames } }: TrailNamesColumnProps): JSX.Element => {
  if (trailNames.length === 0) {
    return null;
  }

  if (trailNames.length === 1) {
    return <span data-testid="alert-trail-names">{trailNames[0]}</span>;
  }

  return (
    <span data-testid="alert-trail-names" title={trailNames.join('\n')}>
      {trailNames.length} trails
    </span>
  );
};

export default TrailNamesColumn;
